/* 
 * Export component file to be used on project
*/

import SimplePersonItem from './SimplePersonItem.js';
export default SimplePersonItem;